import React, { Component } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';

import FilterBarViews from './views';
import { activateFilterPanel } from 'PipeRouter';


class FilterBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentParentIndex: 0
    };

    this.containerRef = null;
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick, true);
  }

  setContainerRef = ref => {
    this.containerRef = ref;
  };

  handleDocumentClick = event => {
    if (!this.containerRef || this.containerRef.contains(event.target)) {
      return;
    }

    const openMenus = this.containerRef.querySelectorAll('ul[role="menu"]');
    const expandedButtons = this.containerRef.querySelectorAll('button[aria-expanded="true"]');

    openMenus.forEach(menu => {
      menu.setAttribute('style', 'display: none;');
    });
    expandedButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
  };

  goToNextMenu = (currentParent, nextParentIndex) => {
    const menus = currentParent.parentElement.getElementsByClassName('menu');

    if (nextParentIndex === menus.length) {
      nextParentIndex = 0;
      return;
    } else if (nextParentIndex < 0) {
      nextParentIndex = menus.length - 1;
    }

    menus[nextParentIndex].focus();
    this.setState({ currentParentIndex: nextParentIndex });
  }

  goToNextMenuFromSubmenu = (currentParent, nextParentIndex, button = "no") => {
    const menuList = currentParent.parentElement.getElementsByClassName('menu');
    const mLen = menuList.length;

    if (nextParentIndex === mLen) {
      menuList[mLen - 1].focus();
      return;
    }

    if (nextParentIndex < 0) {
      menuList[0].focus();
      return;
    }
    if(button === "yes") {
      menuList[nextParentIndex].querySelector('button').focus();
    } else {
      menuList[nextParentIndex].focus();
    }

    this.setState({ currentParentIndex: nextParentIndex });
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
  }

  openFilterPanel = () => {
    this.props.activateFilterPanel();
  }

  updateParentIndex = val => {
    this.setState({ currentParentIndex: val });
  }

  render() {
    const { isMobile } = this.props;
    const { currentParentIndex } = this.state;

    const viewProps = {
      isMobile,
      currentParentIndex,
      containerRef: this.setContainerRef,
      openFilterPanel: this.openFilterPanel,
      goToNextMenuFromSubmenu: this.goToNextMenuFromSubmenu,
      goToNextMenu: this.goToNextMenu,
      updateParentIndex: this.updateParentIndex
    };

    return <FilterBarViews { ...viewProps } />;
  }
}

FilterBar.propTypes = {
  isMobile: bool.isRequired
};

function mapStateToProp(state) {
  const { reader:{ isMobile }} = state;

  return {
    isMobile
  };
}

export default connect(mapStateToProp, {
  activateFilterPanel
})(FilterBar);
